export default "__VITE_ASSET__ClODCWvc__"